export default {
  // 页面描述
  subscribeTitle: '您确定要退订吗？',
  subscribeDesc: '您将不再收到来自 support@aha.inc 的邮件到您的邮箱：',
  cancelTitle: "您已退订。",
  cancelDesc: "很抱歉看到您离开。如果您改变主意，可以随时重新订阅。",
  resultTitle: '您已订阅',
  resultDesc: '谢谢您和我们一起努力',
  // 页面按钮
  button: {
    unsubscribe: '退订',
    resubscribe: '重新订阅',
    waitKeepMeSubscribed: "稍等，保持我订阅状态"
  }
  
};
